import React from 'react';
import { withStyles } from "@mui/styles";
import { Grid, Typography } from '@mui/material';


import en from "../../i18n/English/Policies/rights(terms).json";
import hi from "../../i18n/Hindi/Policies/rights(terms).json";
import kn from "../../i18n/Kannada/Policies/rights(terms).json";
import gu from "../../i18n/Gujarati/Policies/rights(terms).json";
import ma from "../../i18n/Marathi/Policies/rights(terms).json";
import { useLanguage } from "../../Context/LangContext";
import DocumentMeta from 'react-document-meta'

const meta = {
    title: 'Rights & Obligations | Secure NSE & BSE Trading | TradeBoss | Risk Disclosure | Understand Stock Trading Risks | TradeBoss',
    description: 'Understand your trading rights & obligations with TradeBoss. Stay compliant with NSE, BSE policies for safe & transparent investments.Review TradeBoss risk disclosure to trade responsibly. Learn about risks in NSE, BSE & IPO trading and invest with confidence.',
    canonical: 'https://tradeboss.co/termsandconditions, https://tradeboss.co/risk_disclosure',
    meta: {
        charset: 'utf-8',
        name: {
            keywords: 'trading rights and obligations, trader responsibilities NSE BSE, rules for demat account users, legal obligations trading, compliance trading platform, rights of stockholders risk disclosure trading, stock market risk, risks of trading stocks, trading risk policy, understanding investment risk, share market risk NSE BSE'
        }
    }
}
const styles = theme => ({
    heading: {
        textTransform: 'none !important',
        color: '#000000 !important',
        fontFamily: 'Inter500 !important',
        fontSize: 'calc(24px + var(--font-delta)) !important',
        marginBlockStart: 0,
        marginBlockEnd: 0,
        fontWeight: 'normal',
        "@media only screen and (max-device-width: 480px)": {

            fontFamily: 'Inter500 !important',
            fontSize: 'calc(20px + var(--font-delta)) !important',
        }
    },
    p_body: {
        textTransform: 'none !important',
        color: '#000000 !important',
        fontFamily: 'Inter400 !important',
        fontSize: 'calc(16px + var(--font-delta)) !important',
        lineHeight: "22px !important",
        "@media only screen and (max-device-width: 480px)": {

            fontFamily: 'Inter400 !important',
            fontSize: 'calc(14px + var(--font-delta)) !important',
            lineHeight: "20px !important",
        }
    },
    p_body1: {
        textTransform: 'none !important',
        color: '#000000 !important',
        fontFamily: 'Inter400 !important',
        fontSize: 'calc(16px + var(--font-delta)) !important',
        lineHeight: "22px !important",
        marginBlockStart: 0,
        marginBlockEnd: 0,
        fontWeight: 'normal',
        "@media only screen and (max-device-width: 480px)": {

            fontFamily: 'Inter400 !important',
            fontSize: 'calc(14px + var(--font-delta)) !important',
            lineHeight: "20px !important",
        }
    },
});

const Obligations = ({ classes }) => {

      const { language } = useLanguage();
      const translations = { en, hi, kn ,gu ,ma };
      const t = translations[language];
    return (
        <div style={{ height: 'auto' }}>
            <DocumentMeta {...meta} />
            <Grid style={{ padding: '20px 0px 0px 0px' }}>

                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {/* In pursuant to the SEBI circular no CIR/MIRSD/16/2011 dated August 22, 2011 regarding simplification and
                    rationalization of trading account opening process, the uniform documentation set is to be followed by all the
                    stock brokers / trading members. In this regard please find the information on the Rights & Obligations, Risk
                    Disclosure Document, Guidance Note and Policies and Procedures for your reference. */}

                    {t.title}
                </Typography>
                {/* mui typography replaced with html h1 tag - 02/09/24 - Dev Srini */}
                <h1 className={classes.heading} style={{
                    textAlign: 'center', marginTop: '25px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >

                    {/* Rights and Obligations of Stock Brokers, Sub-Brokers and Clients */}
                    {t.heading1}
                </h1>
                <Typography className={classes.p_body1} style={{
                    textAlign: 'center', marginTop: '5px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {/* as prescribed by SEBI and Stock Exchanges */}
                    {t.subheading}
                </Typography>

                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {/* 1. The client shall invest/trade in those securities/contracts/other instruments admitted to dealings on the
                    Exchanges as defined in the Rules, Byelaws and Regulations of Exchanges/Securities and Exchange Board of
                    India (SEBI) and circulars/notices issued there under from time to time. */}

                    {t.points1[0]}
                </Typography>

                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {/* 2. The stock broker, sub-broker and the client shall be bound by all the Rules, Byelaws and Regulations of the
                    Exchanges and circulars/notices issued there under and Rules and Regulations of SEBI and relevant
                    notifications of Government authorities as may be in force from time to time. */}

                    {t.points1[1]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {/* 3. The client shall satisfy itself of the capacity of the stock broker to deal in securities and/or deal in derivatives
                    contracts and wishes to execute its orders through the stock broker and the client shall from time to time
                    continue to satisfy itself of such capacity of the stock broker before executing orders through the stock broker. */}

                    {t.points1[2]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {/* 4. The stock broker shall continuously satisfy itself about the genuineness and financial soundness of the client
                    and investment objectives relevant to the services to be provided. */}
                    {t.points1[3]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {/* 5. The stock broker shall take steps to make the client aware of the precise nature of the Stock broker's liability
                    for business to be conducted, including any limitations, the liability and the capacity in which the stock broker
                    acts. */}
                    {t.points1[4]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {/* 6. The sub-broker shall provide necessary assistance and co-operate with the stock broker in all its dealings
                    with the client(s). */}

                    {t.points1[5]}
                </Typography>
                <h1 className={classes.heading} style={{ padding: '20px 0px 0px 0px' }} >
                    {/* CLIENT INFORMATION */}

                    {t.heading2}
                </h1>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {/* 7. The client shall furnish all such details in full as are required by the stock broker in "Account Opening Form"
                    with supporting details, made mandatory by stock exchanges/SEBI from time to time. */}

                    {t.points2[0]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {/* 8. The client shall familiarize himself with all the mandatory provisions in the Account Opening documents. Any
                    additional clauses or documents specified by the stock broker shall be non-mandatory, as per terms &
                    conditions accepted by the client. */}
                    {t.points2[1]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {/* 9. The client shall immediately notify the stock broker in writing if there is any change in the information in the
                    'account opening form' as provided at the time of account opening and thereafter; including the information on
                    winding up petition/insolvency petition or any litigation which may have material bearing on his capacity. The
                    client shall provide/update the financial information to the stock broker on a periodic basis. */}
                    {t.points2[2]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {/* 10.The stock broker and sub-broker shall maintain all the details of the client as mentioned in the account
                    opening form or any other information pertaining to the client, confidentially and that they shall not disclose the
                    same to any person/authority except as required under any law/regulatory requirements. Provided however
                    that the stock broker may so disclose information about his client to any person or authority with the express
                    permission of the client. */}

                    {t.points2[3]}
                </Typography>
                <h1 className={classes.heading} style={{ padding: '20px 0px 0px 0px' }} >
                    {t.heading3}
                </h1>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {/* 11.The client shall pay applicable initial margins, withholding margins, special margins or such other margins as
                    are considered necessary by the stock broker or the Exchange or as may be directed by SEBI from time to time
                    as applicable to the segment(s) in which the client trades. The stock broker is permitted in its sole and absolute
                    discretion to collect additional margins (even though not required by the Exchange, Clearing House/Clearing
                    Corporation or SEBI) and the client shall be obliged to pay such margins within the stipulated time. */}
                    {t.points3[0]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {/* 12.The client understands that payment of margins by the client does not necessarily imply complete
                    satisfaction of all dues. In spite of consistently having paid margins, the client may, on the settlement of its trade,
                    be obliged to pay (or entitled to receive) such further sums as the contract may dictate/require. */}

                    {t.points3[1]}
                </Typography>
                <h1 className={classes.heading} style={{ padding: '20px 0px 0px 0px' }} >
                    {/* TRANSACTIONS AND SETTLEMENTS */}
                    {t.heading4}
                </h1>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {/* 13.The client shall give any order for buy or sell of a security/derivatives contract in writing or in such form or
                    manner, as may be mutually agreed between the client and the stock broker. The stock broker shall ensure to
                    place orders and execute the trades of the client, only in the Unique Client Code assigned to that client. */}

                    {t.points4[0]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.points4[1]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {t.points4[2]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.points4[3]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.points4[4]}
                </Typography>
                <h1 className={classes.heading} style={{ padding: '20px 0px 0px 0px' }} >
                    {t.heading5}
                </h1>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.points5[0]}
                </Typography>
                <h1 className={classes.heading} style={{ padding: '20px 0px 0px 0px' }} >
                    {t.heading6}
                </h1>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.points6[0]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {t.points6[1]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.points6[2]}
                </Typography>
                <h1 className={classes.heading} style={{ padding: '20px 0px 0px 0px' }} >
                    {t.heading7}
                </h1>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.points7[0]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.points7[1]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {t.points7[2]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.points7[3]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.points7[4]}
                </Typography>
                <h1 className={classes.heading} style={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {t.heading8}
                </h1>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {t.points8[0]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.points8[1]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.points8[2]}
                </Typography>
                <h1 className={classes.heading} style={{ padding: '20px 0px 0px 0px' }} >
                    {t.heading9}
                </h1>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.points9[0]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.points9[1]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.points9[2]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {t.points9[3]}
                    Exchange from time to time where the trade is executed.
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {t.points9[4]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.points9[5]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.points9[6]}
                </Typography>
                <h1 className={classes.heading} style={{ padding: '20px 0px 0px 0px' }} >
                    {t.heading10}
                </h1>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.points10[0]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.points10[1]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.points10[2]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {t.points10[3]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.points10[4]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {t.points10[5]}
                </Typography>
                <h1 className={classes.heading} style={{ padding: '20px 0px 0px 0px' }} >
                    {t.heading11}
                </h1>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.points11[0]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.points11[1]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.points11[2]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.points11[3]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {t.points11[4]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {t.points11[5]}
                </Typography>

                <h1 className={classes.heading} style={{ padding: '20px 0px 0px 0px' }} >
                    {t.heading12}
                </h1>
                <Typography className={classes.p_body1} style={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.subheading12}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.points12[0]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.points12[1]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.points12[2]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {t.points12[3]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {t.points12[4]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.points12[5]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.points12[6]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {t.points12[7]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.points12[8]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.points12[9]}
                </Typography>

                {/* // risk disclosure added - 02-09-24 - Dev Srini */}
                <h1
                    id='risk-disclosure-content'
                    className={classes.heading}
                    style={{ padding: '20px 0px 0px 0px' }}
                >
                    {t.heading13}
                </h1>

                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.points13[0]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.points13[1]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {t.points13[2]}
                </Typography>

                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {t.points13[3]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {t.points13[4]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {t.points13[5]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {t.points13[6]}
                </Typography>
                <h1 className={classes.heading} style={{ padding: '20px 0px 0px 0px' }} >
                    {t.mainheading1}
                </h1>

                <h1 className={classes.p_body1} style={{ padding: '10px 0px 0px 0px' }} >
                    {t.mainpoints1[0].title}
                </h1>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints1[0].text}
                </Typography>
                <h1 className={classes.p_body1} style={{ padding: '10px 0px 0px 0px' }} >
                    {t.mainpoints1[1].title}
                </h1>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints1[1].text}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints1[1].text1}
                </Typography>
                <h1 className={classes.p_body1} style={{ padding: '10px 0px 0px 0px' }} >
                    {t.mainpoints1[2].title}
                </h1>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {t.mainpoints1[2].text}
                </Typography>
                <h1 className={classes.p_body1} style={{ padding: '10px 0px 0px 0px' }} >
                    {t.mainpoints1[3].title}
                </h1>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints1[3].text}
                </Typography>

                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {t.mainpoints1[3].text1}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints1[3].text2}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints1[3].text3}
                </Typography>

                <h1 className={classes.p_body1} style={{ padding: '10px 0px 0px 0px' }} >
                    {t.mainpoints1[4].title}
                </h1>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints1[4].text}
                </Typography>
                <h1 className={classes.p_body1} style={{ padding: '10px 0px 0px 0px' }} >
                    {t.mainpoints1[5].title}
                </h1>

                <Typography className={classes.p_body} style={{
                    padding: '2px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {t.mainpoints1[5].text}
                </Typography>
                <h1 className={classes.p_body1} style={{ padding: '10px 0px 0px 0px' }} >
                    {t.mainpoints1[6].title}
                </h1>

                <Typography className={classes.p_body} style={{
                    padding: '2px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints1[6].text}
                </Typography>

                <Typography className={classes.p_body} style={{
                    padding: '2px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints1[6].text1}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '2px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints1[6].text2}
                </Typography>
                <h1 className={classes.p_body1} style={{ padding: '10px 0px 0px 0px' }} >
                    {t.mainpoints1[7].title}
                </h1>

                <Typography className={classes.p_body} style={{
                    padding: '2px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints1[7].text}
                </Typography>

                <h1 className={classes.p_body1} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints1[8].title}
                </h1>
                <h1 className={classes.p_body1} style={{ padding: '10px 0px 0px 0px' }} >
                    {t.mainpoints1[8].text}
                </h1>

                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints1[8].text1}
                </Typography>

                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints1[8].text2}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints1[8].text3}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {t.mainpoints1[8].text4}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints1[8].text5}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints1[8].text6}
                </Typography>

                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {t.mainpoints1[8].text7}
                </Typography>
                <h1 className={classes.p_body1} style={{ padding: '10px 0px 0px 0px' }} >
                    {t.mainpoints1[9].title}
                </h1>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {t.mainpoints1[9].text}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {t.mainpoints1[9].text1}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {t.mainpoints1[9].text2}
                </Typography>
                <h1 className={classes.p_body1} style={{ padding: '10px 0px 0px 0px' }} >
                    {t.mainpoints1[10].title}
                </h1>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints1[10].text}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {t.mainpoints1[10].text1}
                </Typography>
                <h1 className={classes.p_body} style={{ padding: '10px 0px 0px 0px' }} >
                    {t.mainpoints1[11].title}
                </h1>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints1[11].text}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints1[11].text1}
                </Typography>

                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints1[11].text2}
                </Typography>

                <h1 className={classes.heading} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainheading2}
                </h1>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.subtitle2}
                </Typography>
                <h1 className={classes.heading} style={{ padding: '10px 0px 0px 0px' }} >
                    {t.mainheading3}
                </h1>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints3[0]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {t.mainpoints3[1]}
                </Typography>

                <h1 className={classes.heading} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainheading4}
                </h1>
                <h1 className={classes.heading} style={{ padding: '10px 0px 0px 0px' }} >
                    {t.mainsubheading4}
                </h1>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints4[0]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints4[1]}
                </Typography>

                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints4[2]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints4[3]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints4[4]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints4[5]}
                </Typography>

                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints4[6]}
                </Typography>
                <h1 className={classes.heading} style={{ padding: '10px 0px 0px 0px' }} >
                    {t.mainheading5}
                </h1>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints5[0]}
                </Typography>
                <Typography className={classes.p_body} style={{ padding: '10px 0px 0px 0px' }} >
                    {t.mainpoints5[1]}
                </Typography>
                <Typography className={classes.p_body} style={{ padding: '10px 0px 0px 0px' }} >
                    {t.mainpoints5[2]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints5[3]}
                </Typography>

                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints5[4]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints5[5]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints5[6]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints5[7]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {t.mainpoints5[8]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints5[9]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints5[10]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints5[11]}
                </Typography>
                <h1 className={classes.heading} style={{ padding: '10px 0px 0px 0px' }} >
                    {t.mainheading6}
                </h1>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints6[0]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints6[1]}
                </Typography>
                <h1 className={classes.heading} style={{ padding: '10px 0px 0px 0px' }} >
                    {t.mainheading7}
                </h1>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints7[0]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints7[1]}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints7[2]}
                </Typography>
                <h1 className={classes.heading} style={{ textAlign: 'center', fontSize: 'calc(30px + var(--font-delta))', padding: '10px 0px 0px 0px' }} >
                    {t.mainheading8}
                </h1>
                <h1 className={classes.p_body1} style={{ textAlign: 'center', padding: '2px 0px 0px 0px' }} >
                    {t.subheading8}
                </h1>
                <h1 className={classes.p_body1} style={{ textDecoration: 'underline', padding: '2px 0px 0px 0px' }} >
                    {t.mainpoints8[0].title}
                </h1>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints8[0].text}
                </Typography>
                <h1 className={classes.p_body1} style={{ textDecoration: 'underline', padding: '2px 0px 0px 0px' }} >
                    {t.mainpoints8[1].title}
                </h1>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {t.mainpoints8[1].text}
                </Typography>
                <h1 className={classes.p_body1} style={{ textDecoration: 'underline', padding: '2px 0px 0px 0px' }} >
                    {t.mainpoints8[2].title}
                </h1>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {t.mainpoints8[2].text}
                </Typography>
                <h1 className={classes.p_body1} style={{
                    textDecoration: 'underline', padding: '2px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints8[3].title}
                </h1>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {t.mainpoints8[3].text}
                </Typography>
                <h1 className={classes.p_body1} style={{
                    textDecoration: 'underline', padding: '2px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints8[4].title}
                </h1>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints8[4].text}
                </Typography>
                <h1 className={classes.p_body1} style={{
                    textDecoration: 'underline', padding: '2px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {t.mainpoints8[5].title}
                </h1>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints8[5].text}
                </Typography>

                <h1 className={classes.p_body1} style={{ textDecoration: 'underline', padding: '2px 0px 0px 0px' }} >
                    {t.mainpoints8[6].title}
                </h1>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints8[6].text}
                </Typography>
                <h1 className={classes.p_body1} style={{ textDecoration: 'underline', padding: '2px 0px 0px 0px' }} >
                    {t.mainpoints8[7].title}
                </h1>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {t.mainpoints8[7].text}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {t.mainpoints8[7].text1}
                </Typography>
                <Typography className={classes.p_body} style={{ padding: '10px 0px 0px 0px' }} >
                    {t.mainpoints8[7].text2}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {t.mainpoints8[7].text3}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {t.mainpoints8[7].text4}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {t.mainpoints8[7].text5}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints8[7].text6}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints8[7].text7}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints8[7].text8}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints8[7].text9}

                </Typography>
                <h1 className={classes.p_body1} style={{ textDecoration: 'underline', padding: '2px 0px 0px 0px' }} >
                    {t.mainpoints8[8].title}
                </h1>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints8[8].text}
                </Typography>

                <h1 className={classes.p_body1} style={{
                    textAlign: 'center', padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints8[8].text1}
                </h1>

                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints8[8].text2}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints8[8].text3}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints8[8].text4}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints8[8].text5}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints8[8].text6}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {t.mainpoints8[8].text7}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {t.mainpoints8[8].text8}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {t.mainpoints8[8].text9}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints8[8].text10}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5",
                }} >
                    {t.mainpoints8[8].text11}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {t.mainpoints8[8].text12}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints8[8].text13}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >
                    {t.mainpoints8[8].text14}
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {t.mainpoints8[8].text15}
                </Typography>
            </Grid>
        </div>
    );
};

export default withStyles(styles)(Obligations);